import { render, staticRenderFns } from "./UnlayerEditor.vue?vue&type=template&id=704b3a8f&scoped=true"
import script from "./UnlayerEditor.vue?vue&type=script&lang=js"
export * from "./UnlayerEditor.vue?vue&type=script&lang=js"
import style0 from "./UnlayerEditor.vue?vue&type=style&index=0&id=704b3a8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b3a8f",
  null
  
)

export default component.exports